import SessionEventProto from "../session-event-proto"
import {EntityType} from "../../gd/const/item"

export type SessionEventCommentHeader = {
    comment         : {
        parentEntityType: EntityType
        parentEntityId  : ID
        id              : ID
    }
    isBulkUpdate    : boolean
}

const debug = false
// const debug = "SessionCommentEvent"

export default class SessionCommentEvent extends SessionEventProto {

    private header  : SessionEventCommentHeader

    constructor(sessionEvent:any) {
        super(sessionEvent)
        this.header     = {
            comment         : sessionEvent.comment,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    process() {
        if (this.isDifferentCompany()) return false

        debug && console.log(debug, 'process', this.data.type, this.data)

        gd.modelBus.newUpdate('comment', this.method, this.header.comment.id, this.data, this.header)
    }
}
